import React, { useState } from "react";
import { ExcelFileType, exportToExcel } from "../helper/exportToExcel";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import moment from "moment";

interface DropdownProps<T> {
  data: T[];
  excelheader: string[];
  start?: Date | null;
  end?: Date | null;
  reportName?: string;
  removetopStyle?: boolean;
}

const ExportDropdown = <T extends Record<string, string | number | boolean | Date | null>>({ data, excelheader, start, end, reportName, removetopStyle = false }: DropdownProps<T>) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button
        id='dropdownDefaultButton'
        data-dropdown-toggle='dropdown'
        onClick={toggleDropdown}
        className={`text-white bg-blue-700 ${removetopStyle ? '' : 'mt-2 lg:mt-9'} justify-between hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
        type='button'
      >
        Export <MdOutlineKeyboardArrowDown size={20} />
      </button>

      {/* Dropdown menu */}
      <div
        onMouseLeave={() => setIsOpen(false)}
        id='dropdown'
        className={`z-10 ${
          isOpen ? "block" : "hidden"
        } bg-white divide-y divide-gray-100 px-5  rounded-lg absolute shadow w-44 dark:bg-gray-700 dark:divide-gray-600`}
      >
        <ul
          className='py-2 text-sm text-gray-700 dark:text-gray-200'
          aria-labelledby='dropdownInformationButton'
        >
          {["xlsx", "xls", "csv"].map((item) => (
            <li
              className='uppercase py-2 cursor-pointer text-sm'
              key={item}
              onClick={() =>
                exportToExcel({
                  data: data ?? [],
                  excelheader,
                  fileName: reportName ? reportName : `Reports-${moment(start).format("DD MMM YYYY")} to ${moment(end).format("DD MMM YYYY")}`,
                  fileType: item as ExcelFileType,
                })
              }
            >
              Export to {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ExportDropdown;
